import {fromJS} from 'immutable'
import { 
  LOG_USER,
  REGISTRA_USER,
  LOGOUT_USER,
  TRAE_USER,
  SEND_USER,
  ADD_DIRECCION,
  UPDATE_DIRECCION,
  DEL_DIRECCION,
  TRAE_DIRECCION,
  TRAE_DIRECCIONES,
  ADD_PEDIDO,
  SEND_USER_MSJ,
  UPDATE_STAT,
  RESET_PASS,
  ENVIA_CONTACTO,
  TRAE_PROVINCIAS,
  TRAE_CIUDADES
} from '../actions'
import moment from 'moment'


const initialHeader = {
 
  user:null,
  perfil:{},
  direcciones:[],
  provincias:[],
  ciudades:[],
  pedidos:[], 
  msj:{
    tipo:1,
    contenido:""
  },
  tipo:"u",
  envio:null,
  inAction:false, 
  contador:1
}

const usuario = (state = initialHeader, action) => {
  
    const estadoNuevo = Object.assign({}, state)
    const datosNuevo = fromJS(estadoNuevo)

  switch (action.type) {

    case LOG_USER:
      var msj={
        tipo:1,
        contenido:""
      }
      const userLogSend = datosNuevo.updateIn(['user'],value => action.user)
      const perfilLogSend = userLogSend.updateIn(['perfil'],value => action.perfil)
      const msjClean = perfilLogSend.updateIn(['msj'],value =>msj)
      const tipoLogin = msjClean.updateIn(['tipo'],value => action.tipo)
      return tipoLogin.toJSON()

    case REGISTRA_USER:
      const userRegistroSend = datosNuevo.updateIn(['user'],value => action.user)
      const perfilRegistroSend = userRegistroSend.updateIn(['perfil'],value => action.perfil)
      const tipoRegistro = perfilRegistroSend.updateIn(['tipo'],value => "u")
      return tipoRegistro.toJSON()

    case LOGOUT_USER:
     var msj={
        tipo:1,
        contenido:""
      }
      const userLogOUtSend = datosNuevo.updateIn(['user'],value => null)
      const perfilLogOUtSend = userLogOUtSend.updateIn(['perfil'],value => {})
      const msjCleanOut = perfilLogOUtSend.updateIn(['msj'],value => msj)
      const tipoOut = msjCleanOut.updateIn(['tipo'],value => "u")
      return tipoOut.toJSON()

    case ADD_DIRECCION:
      return datosNuevo.toJSON()

    case UPDATE_DIRECCION:
      return state
    case DEL_DIRECCION:
      return state
    case TRAE_DIRECCION:
      return state
    case TRAE_DIRECCIONES:
      return state
    case ADD_PEDIDO:
      return state
    case UPDATE_STAT:
      const userStatSend = datosNuevo.updateIn(['user'],value => action.user)
      const perfilStatSend = userStatSend.updateIn(['perfil'],value => action.perfil)
      const tipoStatSend = perfilStatSend.updateIn(['tipo'],value => action.tipo)
      return tipoStatSend.toJSON()

    case SEND_USER_MSJ:
      var msj = {
        contenido:action.msj,
        tipo:action.tipo
      }
      const msjSend = datosNuevo.updateIn(['msj'],value => msj)
      return msjSend.toJSON()

    case RESET_PASS:
      var msj = {
        contenido:action.msj,
        tipo:action.tipo
      }
      const resetPass = datosNuevo.updateIn(['msj'],value => msj)
      return resetPass.toJSON()

    case ENVIA_CONTACTO:
      console.log(action.payload)
      var msj = { contenido: action.payload.msj, tipo: 1, momento: moment().unix() };
      var msj_contacto = { mensaje: action.payload.msj, resp: action.payload.resp, momento: moment().unix() };
      console.log(msj_contacto)
      const enviaContacto = datosNuevo.updateIn(['msj'], value => msj)
      const enviaContactoMsj = enviaContacto.updateIn(["envio"], value => msj_contacto);
      return enviaContactoMsj.toJSON()
    
    case SEND_USER:
      var contador=parseInt(state.contador)+1
      var perfilNuevo=action.perfil
      perfilNuevo.nombre = state.perfil.nombre;
      perfilNuevo.apellido = state.perfil.apellido;
      const perfilUpdateSend = datosNuevo.updateIn(["perfil"], value => perfilNuevo);
      const addCounter = perfilUpdateSend.updateIn(["contador"], value => contador);
      return addCounter.toJSON();

    case TRAE_CIUDADES:
      console.log(action)
      const ciudadesNew = datosNuevo.updateIn(["ciudades"], value => action.ciudades.data.localidades);
      return ciudadesNew.toJSON();

    case TRAE_PROVINCIAS:
      const provinciasNew = datosNuevo.updateIn(["provincias"], value => action.provincias.data.provincias);
      return provinciasNew.toJSON();

    default:  
      return state
  }
}

export default usuario


// WEBPACK FOOTER //
// ./src/reducers/usuario.js